__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/45ceb6c/_next/";